import { useHistory, useLocation } from 'react-router-dom'

import { useIsBlaze } from 'hooks/useIsBlaze'
import Styles from '../PublishHandbook.module.scss'
import { DomainCalloutProps } from './Types'

export const DomainCallout = ({ workspaceDomain, entityType = 'handbook' }: DomainCalloutProps) => {
  const history = useHistory()
  const location = useLocation()
  const isBlaze = useIsBlaze()
  const domain = isBlaze ? 'blaze.ai' : 'almanac.io'

  const title = () => {
    if (!workspaceDomain) return 'Change the URL into a domain or subdomain'
    if (workspaceDomain.subdomain) return 'Change the URL into a domain or Blaze default.'
    return 'Change the URL into a subdomain or Blaze default.'
  }

  const options = () => {
    if (!workspaceDomain)
      return (
        <>
          <div>“https://company.com/{entityType}</div>
          <div>
            “https://company.{domain}/{entityType}”
          </div>
        </>
      )
    if (workspaceDomain.subdomain)
      return (
        <>
          <div>“https://company.com/{entityType}”</div>
          <div>
            “https://{domain}/company/{entityType}”
          </div>
        </>
      )
    return (
      <>
        <div>
          “https://company.{domain}/{entityType}”
        </div>
        <div>
          “https://{domain}/company/{entityType}”
        </div>
      </>
    )
  }

  const openWorkspaceSettings = () => {
    const queryParams = new URLSearchParams(location.search)
    queryParams.set('settings', 'general')
    history.push({ search: queryParams.toString() })
  }

  return (
    <button className={Styles.domainCallout} onClick={openWorkspaceSettings}>
      <div className={Styles.title}>{title()}</div>
      <div className={Styles.urlOptions}>{options()}</div>
    </button>
  )
}
